// extracted by mini-css-extract-plugin
export default {"isExpanding":"PageContainer_isExpanding_DlXS8","expander":"PageContainer_expander_AcXVf","innerExpander":"PageContainer_innerExpander_C8RXZ","sidebar":"PageContainer_sidebar_Mhjli"};